export const QUEST_GENERATION_PENDING_STATUSES = new Set([
  'started',
  'already_running',
  'restarted_after_stale',
]);

const defaultTranslate = (key, fallback = key) => fallback;

export const getQuestGenerationLoadingCopy = (requestStatus, t = defaultTranslate) => {
  switch (requestStatus) {
    case 'already_running':
      return {
        title: t('questGenerationLoading.alreadyRunningTitle', 'Quest Regeneration Already Running...'),
        subtitle: t('questGenerationLoading.alreadyRunningSubtitle', 'Reconnecting to an existing plan build'),
      };
    case 'restarted_after_stale':
      return {
        title: t('questGenerationLoading.restartedTitle', 'Restarting Your Plan...'),
        subtitle: t('questGenerationLoading.restartedSubtitle', 'A previous stuck generation was cleared automatically'),
      };
    case 'started':
    default:
      return {
        title: t('questGenerationLoading.title', 'Building Your Plan...'),
        subtitle: t('questGenerationLoading.subtitle', 'Reviewing your preferences & goals'),
      };
  }
};

export const shouldNavigateToQuestGenerationDashboard = (requestStatus) =>
  QUEST_GENERATION_PENDING_STATUSES.has(requestStatus);

export const shouldBootstrapQuestGenerationPoll = ({
  aggregate,
  quests,
  generationStatus,
  isGenerating,
  generationFinished,
}) => Boolean(
  aggregate?.user?.onboardingComplete
  && !aggregate?.user?.isRecoveryMode
  && Array.isArray(quests)
  && quests.length === 0
  && generationStatus?.state === 'idle'
  && !isGenerating
  && !generationFinished
);
